import React from "react"
import { FormControl, OverlayTrigger } from "react-bootstrap"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./DateField.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    templateField?: boolean
    configField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function DateField(props: Props) {

    // console.log("df_FieldDateField props", props)

    const field = props.field
    const value = !props.formManagerField ? field.Value : null
    const name = field.Name || "Date"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    return (
        <div className={`DynamicForm${fieldType} DynamicFormDate${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                    {field.Required && !field.Value && <span className="material-icons" style={{ color: `${paletteEngine.getPaletteColor("requiredFieldAsteriskColor")}` }}>*</span>}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                <FormControl
                    onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "Value" } }])}
                    //@ts-ignore
                    onChange={props.handleChange}
                    id="dynamic-form-date-picker"
                    value={value || ""}
                    type="date"
                    disabled={props.formManagerField}
                    style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`, color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}` }}
                />
            </div>
        </div>
    )
}

export default DateField